import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from "react-redux";
import { MdMenuOpen } from "react-icons/md";

import classes from './NavigationHeader.module.scss'

import PersonalProfileToggle from '../PersonalProfileToggle/PersonalProfileToggle';
import BugReportButton from '../../BugReport/BugReportButton/BugReportButton';
import UnderlinedLink from '../../UI/UnderlinedLink/UnderlinedLink';
import NotificationPanel from "../Notifications/NotificationPanel";

const NavigationHeader = (props) => {
    const user = useSelector(state => state.auth.user);
    const isIlliquid = useSelector(state => state.auth.isIlliquid)

    return (
        <div className={`NavigationHeader_navbar_color ${classes.navbar}`}>
            <button className={classes.mobileSidebarToggle} onClick={props.mobileToggleClicked} aria-label="toggle sidebar">
                <MdMenuOpen size={25} />
            </button>
            <NavLink exact to="/" className={`${classes.titleContainer} NavigationHeader_text_color`}>
                ИИС «БГУИР: Университет»
            </NavLink>
            <div className={classes.navigationItemsContainer}>
                {/* <SystemCustomizationToggle setLanguage={props.setLanguage} /> */}

                {props.location.pathname !== "/support" && <BugReportButton getImage={props.getImage} />}
                {(user && !isIlliquid && user.authorities.indexOf("ROLE_ADMIN") === -1) ? <NotificationPanel/> : null}
                {(!user || isIlliquid )
                    ? <UnderlinedLink href="/login" text="Войти" routing={true} />
                    : <PersonalProfileToggle {...props} />
                }
            </div>
        </div>
    )
};

export default NavigationHeader;
